//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'birthday_nav_delivery',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};